import { useState, useEffect } from 'react';

const useScreenWidth = () => {
	const [isScreenWidthSmall, setIsScreenWidthSmall] = useState(window.innerWidth < 900);

	useEffect(() => {
		const handleResize = () => {
			setIsScreenWidthSmall(window.innerWidth < 900);
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return isScreenWidthSmall;
};

export default useScreenWidth;